"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _radio = _interopRequireDefault(require("britive-design-system/core/components/radio"));

var _constants = require("./constants");

var _excluded = ["resource", "includeHierarchy", "classes", "translatedStrings"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line react/prop-types
var IncludeHierarchy = function IncludeHierarchy(_ref) {
  var resource = _ref.resource,
      includeHierarchy = _ref.includeHierarchy,
      classes = _ref.classes,
      translatedStrings = _ref.translatedStrings,
      rest = _objectWithoutProperties(_ref, _excluded);

  return resource !== _constants.rootNodePath ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, rest)) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings.includeHierarchyBelowPath, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, includeHierarchy ? translatedStrings.yesLabel : translatedStrings.noLabel)));
};

IncludeHierarchy.propTypes = {
  resource: _propTypes.default.any,
  includeHierarchy: _propTypes.default.string,
  classes: _propTypes.default.object,
  translatedStrings: _propTypes.default.object
};
var _default = IncludeHierarchy;
exports.default = _default;